import * as React from 'react';
import { useContext } from 'react';

import { type SkillEntity } from 'bundles/browse-common/types/Skill';

export type SkillEntityContextType = SkillEntity;

const SkillEntityContext = React.createContext<SkillEntityContextType | undefined>(undefined);

export const useSkillEntity = () => {
  return useContext(SkillEntityContext);
};

export default SkillEntityContext;
